export default {
    path: '/rentdetail',
    meta: {
        title: '租约详情',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/rentdetail`),
}


// WEBPACK FOOTER //
// ./src/views/RentDetail/router.js